import { axiosInstance } from "./axiosInstance";

const nitroposURL = process.env.REACT_APP_NITROPOS;

const getSites = async () => {
  return axiosInstance
    .get("https://nitrous.rt-itservices.co.uk/sites/data")
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      return "error";
    });
};

const getSuppliers = async () => {
  return axiosInstance
    .get(`${nitroposURL}/eposSQL/getSuppliers`)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      return "error";
    });
};

const getPicklistStatuses = async () => {
  return axiosInstance
    .get(`${nitroposURL}/picklist/statuses`)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      return "error";
    });
};

const getAllPicklists = async (
  limit: number,
  page: number,
  suppliers?: any[]
) => {
  return axiosInstance
    .post(`${nitroposURL}/picklist/all`, { limit, page, suppliers })
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      return "error";
    });
};

const getPickListById = async (id: any) => {
  return axiosInstance
    .get(`${nitroposURL}/picklist/list/${id}`)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      return "error";
    });
};

const getCategories = async () => {
  return axiosInstance
    .get(`${nitroposURL}/eposSQL/warehouse/categories`)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      return "error";
    });
};

const getProductsByCatId = async (id: number) => {
  return axiosInstance
    .post(`${nitroposURL}/eposSQL/warehouse/categories/products`, {
      categoryId: id,
    })
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      return "error";
    });
};

const getProductsBySupId = async (id: number) => {
  return axiosInstance
    .post(`${nitroposURL}/eposSQL/warehouse/supplier/products`, {
      supplierId: id,
    })
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      return "error";
    });
};

const getProductsByVal = async (val: string) => {
  return axiosInstance
    .get(`${nitroposURL}/eposSQL/warehouse/product/search/${val}`)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      return "error";
    });
};

const mergePicklists = async (list: string[]) => {
  return axiosInstance
    .post(`${nitroposURL}/picklist/merge`, {
      list: list,
    })
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      return "error";
    });
};

const ShowMergedPicklists = async (id: string) => {
  return axiosInstance
    .get(`${nitroposURL}/picklist/merge/${id}`)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      return "error";
    });
};
const updatePicklList = async (
  plHeadId: string,
  plItemId: string,
  newQuantity: string,
  user: string
) => {
  return axiosInstance
    .post(`${nitroposURL}/picklist/change/products`, {
      plHeadId: plHeadId,
      plItemId: plItemId,
      newQuantity: newQuantity,
      user: user,
    })
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      return "error";
    });
};
const GetPO = async (id: string) => {
  return axiosInstance
    .get(`${nitroposURL}/picklist/mergePos/${id}`)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      return "error";
    });
};

export {
  getSites,
  getSuppliers,
  getPicklistStatuses,
  getAllPicklists,
  getPickListById,
  getCategories,
  getProductsByCatId,
  getProductsBySupId,
  getProductsByVal,
  mergePicklists,
  ShowMergedPicklists,
  updatePicklList,
  GetPO,
};
